import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=a56ca5bc&scoped=true&"
import script from "./MediaModal.vue?vue&type=script&lang=js&"
export * from "./MediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ca5bc",
  null
  
)

export default component.exports